import React from 'react';
import { ShieldCheck, Gem, HeartHandshake, MapPin } from 'lucide-react';
import { aboutStory, brand } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const pillarIcons = [ShieldCheck, Gem, HeartHandshake];

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 md:py-32 bg-[#0B3D2E] relative overflow-hidden">
      <div className="absolute -top-20 right-0 w-[36rem] h-[36rem] rounded-full bg-[#D4AF37]/8 blur-[120px] pointer-events-none" />

      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] text-xs tracking-[0.22em] uppercase mb-7">
              <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
              {t('about.kicker')}
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.1] text-[#ffffff] mb-8">
              {t('about.title')}
              <span className="peach-text italic block">{t('about.title.italic')}</span>
            </h2>

            <div className="flex flex-wrap items-center gap-3 mb-8">
              {brand.locations.map((loc) => (
                <div
                  key={loc.id}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#124D3A] border border-[#D4AF37]/20 text-sm text-[#ffffff]/85"
                >
                  <MapPin className="w-3.5 h-3.5 text-[#D4AF37]" />
                  <span className="text-base">{loc.flag}</span>
                  <span>{loc.city}, {loc.country}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 space-y-5 text-[#ffffff]/80 leading-relaxed text-[17px]">
            <p>{t('about.p1')}</p>
            <p>{t('about.p2')}</p>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 gap-5 mt-16">
          {aboutStory.pillars.map((pillar, i) => {
            const Icon = pillarIcons[i] || ShieldCheck;
            return (
              <div
                key={pillar.title}
                className="group relative rounded-2xl p-8 bg-[#124D3A] border border-[#D4AF37]/15 hover:border-[#D4AF37]/40 transition-all card-hover overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#D4AF37]/5 group-hover:bg-[#D4AF37]/10 transition-colors blur-2xl pointer-events-none" />
                <div className="relative">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                    style={{ background: 'linear-gradient(135deg, #F6E3A1 0%, #D4AF37 50%, #A8832E 100%)' }}
                  >
                    <Icon className="w-5 h-5 text-[#0B3D2E]" />
                  </div>
                  <h3 className="font-serif-display text-2xl text-[#ffffff] mb-2">{t(`about.pillar.${i}.title`, pillar.title)}</h3>
                  <p className="text-sm text-[#ffffff]/70 leading-relaxed">{t(`about.pillar.${i}.text`, pillar.text)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
